export enum NewTabUrlSource {
	copyUrl = "copyUrl",
	query = "query"
}